import styled, { keyframes } from 'styled-components';

export const StatusPageMainContainer = styled.div`
  margin: 32px;
  display: flex;
  flex-direction: column;
  height: 90vh;
  width: 80vw;
  overflow: hidden;
`;

export const Header = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #101828;
`;

export const SubHeader = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #667085;
`;

export const DashboardContainer = styled.div`
  margin-top: 16px;
  padding: 16px;
  background-color: black;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  border-radius: 8px;
  overflow-y: auto;
`;

export const RobotStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RobotStatusHeader = styled.div`
  padding: 10px;
`;

export const RobotStatusBody = styled.div`
  padding: 10px;
  display: flex;
  gap: 12px;
  flex-direction: row;
`;

export const FixedScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  overflow-x: auto;
`;

export const ColumnGroup = styled.div`
  display: flex;
  flex-direction: row;
  border: 2px solid #4AF1F2;
  border-radius: 10px;
  gap: 12px;
  padding: 12px;
`;

export const StatusCol = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  border: 0.5px solid white;
  border-radius: 2px;
  padding: 10px;
  justify-content: center;
`;

export const StatusCard = styled.div`
  min-width: 100px;
  max-height: 150px;
  border: 0.5px solid white;
  border-radius: 2px;
  background-color: rgba(128, 128, 128, 0.4);
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px;
`;

const dataChangeAnimation = keyframes`
  0% { color: var(--text-color, white);}
  25% { color: white;}
  100% { color: var(--text-color, white);}
`;

export const StatusCardData = styled.div`
  /* Define text-color variable from props */
  --text-color: ${(props) => (
    props.isTitle ? "#FF7518":
    props.isInfo ? "#FFFFFF":
    props.isActiveData ? "#FF3131":
    "#49d130"
    )
  };

  color: var(--text-color);
  font-weight: ${(props) => (
    props.isTitle ? "bold" : "normal"
    )
  };
  animation: ${dataChangeAnimation} 1s ease-out;
  display: flex;
  justify-content: center;
`;

export const EmptyStatusCol = styled.div`
  min-width: 55vw;
`;